import { useQuery, keepPreviousData } from '@tanstack/react-query'
import { api, type InvoicesListParams } from '@/lib/api-client'

/**
 * Hook to fetch paginated invoices list
 */
export function useInvoices(params?: InvoicesListParams) {
  return useQuery({
    queryKey: ['invoices', params],
    queryFn: () => api.invoices.list(params),
    placeholderData: keepPreviousData, // Smooth pagination transitions
    staleTime: 30 * 1000, // 30 seconds
  })
}

/**
 * Hook to fetch single invoice with items
 */
export function useInvoice(id: number | null) {
  return useQuery({
    queryKey: ['invoice', id],
    queryFn: () => api.invoices.get(id!),
    enabled: id !== null && id > 0,
    staleTime: 60 * 1000, // 1 minute
  })
}

/**
 * Hook to fetch invoice items with pagination
 */
export function useInvoiceItems(
  id: number | null,
  params?: { page?: number; pageSize?: number }
) {
  return useQuery({
    queryKey: ['invoice', id, 'items', params],
    queryFn: () => api.invoices.items(id!, params),
    enabled: id !== null && id > 0,
    placeholderData: keepPreviousData,
  })
}
